import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import '../../../css/qualificationOverlay.css';

const QualificationOverlay = ({ qualification, onClose, onUpdate }) => {
  const [editData, setEditData] = useState({ name: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (qualification) {
      setEditData({ name: qualification.name || '' });
    }
  }, [qualification]);

  const handleChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      await api.put(`/qualifications/${qualification.id}`, editData, {
        headers: { 'Content-Type': 'application/json' }
      });
      setSuccess('Qualifica aggiornata con successo!');
      if (onUpdate) onUpdate();
      setTimeout(() => onClose(), 1500);
    } catch (err) {
      console.error("Errore nell'aggiornamento della qualifica:", err);
      setError("Errore nell'aggiornamento della qualifica.");
    }
  };

  return (
    <div className="qualification-overlay-container" onClick={onClose}>
      <div className="qualification-overlay-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>
        <h2>Modifica Qualifica</h2>
        {error && <p className="error">{error}</p>}
        {success && <p className="success">{success}</p>}
        <form onSubmit={handleSubmit}>
          <label>
            Nome:
            <input
              type="text"
              name="name"
              value={editData.name}
              onChange={handleChange}
              required
            />
          </label>
          <button type="submit">Salva</button>
        </form>
      </div>
    </div>
  );
};

export default QualificationOverlay;
